/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  getAddressEncoder,
  getProgramDerivedAddress,
  getUtf8Encoder,
  type Address,
  type ProgramDerivedAddress,
} from "@solana/kit";

export type ClaimFeeOperatorSeeds = {
  /** The operator address */
  operator: Address;
};

/**
 * A claim fee operator account that authorizes an address to claim protocol fees.
 * Operators can collect fees on behalf of the protocol.
 */
export async function findClaimFeeOperatorPda(
  seeds: ClaimFeeOperatorSeeds,
  config: { programAddress?: Address | undefined } = {},
): Promise<ProgramDerivedAddress> {
  const {
    programAddress = "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG" as Address<"cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG">,
  } = config;
  return await getProgramDerivedAddress({
    programAddress,
    seeds: [
      getUtf8Encoder().encode("cf_operator"),
      getAddressEncoder().encode(seeds.operator),
    ],
  });
}
